import { useMutation } from "react-query";
import { toast } from "../../../../../components/toastNotification";
import { deleteMasterLegalEntity } from "../../../../../actions/Utilities/MasterLegalEntity";
import { masterLegalEntityFetching } from "../atoms/atoms";
import { useRecoilState, useSetRecoilState } from "recoil";

const useDeleteMasterLegalEntity = () => {
  const [isReFetching, setIsReFetching] = useRecoilState(
    masterLegalEntityFetching
  );
  const { mutate } = useMutation(
    (ids: number[]) => deleteMasterLegalEntity(ids),
    {
      onSuccess: (res: any) => {
        switch (true) {
          case res == "Success":
            toast.fire(
              "Success",
              "Business Type Disabled Successfully",
              "success"
            );
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Business Type Disabled Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Disabling Business Type failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "Business Type not found":
            toast.fire(
              "Disabling Business Type failed ",
              `Error: ${res}`,
              "error"
            );
            break;
          default:
            toast.fire("Disabling Business Type failed", res.Message, "error");
        }

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error) => {
        toast.fire(
          "Disabling Business Type failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );

  return mutate;
};
export default useDeleteMasterLegalEntity;
